import Header from '../Component/Header'
import Breadcrumb from "../Component/Breadcrumb";
import Footer from '../Component/Footer' 
import { useNavigate } from 'react-router-dom';
const Magazine = ()=>{
    
    const navigate = useNavigate();
    return(

        <>
        <Header />
            <Breadcrumb title="School Magazine" tabName="School Magazine" />
            <div className="innerPage">
                <div className="container">
                    <div className="row">  
                    <div className='col-lg-7 col-md-6 col-sm-12 mb-3'>
                            <p className="magazinebg"><b>Beginning of a creative future.</b></p>
                            <p className="magazinebg">Nirmalight - The School Magazine was launched in 2008. As the name suggests, it brings you the sparkle of the nirmal (pure) light of wisdom of Nirmalites. It is a milestone and means different things to different persons. It is a platform to bring out the latent talents of the students and encourage them to find their feet in the literary world. The magazine was aimed to help students in this infotech world to think faster, formulate and express ideas quickly and to develop a creative imagination to solve problems and respond to various issues of the society.</p>
                            </div> 
                        <div className='col-lg-5 col-md-6 col-sm-12 mb-3'>
                            <p className='magazine_blk_p'>Nirmalight Vol 14</p>
                                <div className='magazine_blk magazine-height'>
                                    <a target="_blank"  onClick={() => navigate("/magazine1", { state: { magazine: "2" } })}>
                                        <img src="https://webapi.entab.info/api/image/NCSR/public/Images/magazine-2024-2025/1.jpg" className='magazine-block img-fluid' />
                                        <button className='mt-4'>View</button>
                                    </a>
                                </div>
                            </div> 
                       
                          
                    </div>
                    <div className='row'> 
                   




                    <div className='col-lg-4 col-md-6 col-sm-6'>
                        <p className='magazine_blk_p'>Maria Teresa Unzu</p>
                            <div className='magazine_blk new_magazine'>
                                <a target="_blank"  onClick={() => navigate("/magazine1", { state: { magazine: "3" } })}>
                                    <img src="https://webapi.entab.info/api/image/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-1.jpg" className='magazine-block img-fluid' />
                                    <button className='mt-4'>View</button>
                                </a>
                            </div>
                        </div> 
                        <div className='col-lg-4 col-md-6 col-sm-6'>
                        <p className='magazine_blk_p'>Golden Jubilee Souvenir</p>
                        <div className='magazine_blk new_magazine'>
                        <a target="_blank"  onClick={() => navigate("/magazine1", { state: { magazine: "5" } })}>
                                    <img src="https://webapi.entab.info/api/image/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir1.jpg" className='magazine-block img-fluid' />
                                   
                                    <button className='mt-4'>View</button>
                                </a>
                            </div>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-6'>
                        <p className='magazine_blk_p'>Silver Jubilee Souvenir</p>
                        <div className='magazine_blk new_magazine'>
                        <a target="_blank" href="https://drive.google.com/file/d/1UcpW9jeIxIgC9X9cimHHz0Zv5cTBI81l/view">
                                    <img src="https://webapi.entab.info/api/image/NCSR/public/Images/silver-Jubllee-Souvenir1.jpg" className='magazine-block img-fluid' />
                                   
                                    <button className='mt-4'>View</button>
                                </a>
                            </div>
                        </div>
                    

                       
                      
                        
                     </div>
                     <div className='row'>
                       
                        
                        <div className='col-xxl-2 col-xl-3 col-lg-4 col-md-4 col-sm-4'>
                        <p className='magazine_blk_p'> Nirmalight Vol 13</p>
                        <div className='magazine_blk'>
                        <a target="_blank"  onClick={() => navigate("/magazine1", { state: { magazine: "1" } })}>
                                    <img src="https://webapi.entab.info/api/image/NCSR/public/Images/magazine/1.jpg" className='magazine-block img-fluid' />
                                   
                                    <button className='mt-4'>View</button>
                                </a>
                            </div>
                        </div>
                        <div className='col-xxl-2 col-xl-3 col-lg-4 col-md-4 col-sm-4'>
                        <p className='magazine_blk_p'>Nirmalight Vol 12</p>
                        <div className='magazine_blk'>
                        <a target="_blank"  onClick={() => navigate("/magazine1", { state: { magazine: "12" } })}>
                                    <img src="https://webapi.entab.info/api/image/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-1 copy.jpg" className='magazine-block img-fluid' />
                                   
                                    <button className='mt-4'>View</button>
                                </a>
                            </div>
                        </div>
                        <div className='col-xxl-2 col-xl-3 col-lg-4 col-md-4 col-sm-4'>
                        <p className='magazine_blk_p'>Nirmalight vol-11</p>
                            <div className='magazine_blk'>
                                <a target="_blank"  onClick={() => navigate("/magazine1", { state: { magazine: "17" } })}>
                                    <img src="https://webapi.entab.info/api/image/NCSR/public/Images/vol-2025/nirmalight-vol-11-1.jpg" className='magazine-block img-fluid' />
                                    <button className='mt-4'>View</button>
                                </a>
                            </div>
                        </div> 
                        <div className='col-xxl-2 col-xl-3 col-lg-4 col-md-4 col-sm-4'>
                        <p className='magazine_blk_p'>Nirmalight vol-10</p>
                            <div className='magazine_blk'>
                                <a target="_blank"  onClick={() => navigate("/magazine1", { state: { magazine: "16" } })}>
                                    <img src="https://webapi.entab.info/api/image/NCSR/public/Images/vol-2025/nirmalight-vol-10-1.jpg" className='magazine-block img-fluid' />
                                    <button className='mt-4'>View</button>
                                </a>
                            </div>
                        </div> 
                        <div className='col-xxl-2 col-xl-3 col-lg-4 col-md-4 col-sm-4'>
                        <p className='magazine_blk_p'>Nirmalight vol-9</p>
                            <div className='magazine_blk'>
                                <a target="_blank"  onClick={() => navigate("/magazine1", { state: { magazine: "15" } })}>
                                    <img src="https://webapi.entab.info/api/image/NCSR/public/Images/vol-2025/nirmalight-vol-9-1.jpg" className='magazine-block img-fluid' />
                                    <button className='mt-4'>View</button>
                                </a>
                            </div>
                        </div> 
                        <div className='col-xxl-2 col-xl-3 col-lg-4 col-md-4 col-sm-4'>
                        <p className='magazine_blk_p'>Nirmalight vol-8</p>
                            <div className='magazine_blk'>
                                <a target="_blank"  onClick={() => navigate("/magazine1", { state: { magazine: "14" } })}>
                                    <img src="https://webapi.entab.info/api/image/NCSR/public/Images/vol-2025/nirmalight-vol-8-1.jpg" className='magazine-block img-fluid' />
                                    <button className='mt-4'>View</button>
                                </a>
                            </div>
                        </div> 
                        <div className='col-xxl-2 col-xl-3 col-lg-4 col-md-4 col-sm-4'>
                        <p className='magazine_blk_p'>Nirmalight vol-7</p>
                            <div className='magazine_blk'>
                                <a target="_blank"  onClick={() => navigate("/magazine1", { state: { magazine: "13" } })}>
                                    <img src="https://webapi.entab.info/api/image/NCSR/public/Images/vol-2025/nirmalight-vol-7-1.jpg" className='magazine-block img-fluid' />
                                    <button className='mt-4'>View</button>
                                </a>
                            </div>
                        </div> 
                        <div className='col-xxl-2 col-xl-3 col-lg-4 col-md-4 col-sm-4'>
                        <p className='magazine_blk_p'>Nirmalight Vol 6</p>
                        <div className='magazine_blk'>
                        <a target="_blank"  onClick={() => navigate("/magazine1", { state: { magazine: "11" } })}>
                                    <img src="https://webapi.entab.info/api/image/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-1 copy.jpg" className='magazine-block img-fluid' />
                                   
                                    <button className='mt-4'>View</button>
                                </a>
                            </div>
                        </div>
                        <div className='col-xxl-2 col-xl-3 col-lg-4 col-md-4 col-sm-4'>
                        <p className='magazine_blk_p'>Nirmalight Vol 5</p>
                        <div className='magazine_blk'>
                        <a target="_blank"  onClick={() => navigate("/magazine1", { state: { magazine: "10" } })}>
                                    <img src="https://webapi.entab.info/api/image/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-1 copy.jpg" className='magazine-block img-fluid' />
                                   
                                    <button className='mt-4'>View</button>
                                </a>
                            </div>
                        </div>
                        <div className='col-xxl-2 col-xl-3 col-lg-4 col-md-4 col-sm-4'>
                        <p className='magazine_blk_p'>Nirmalight Vol 4</p>
                        <div className='magazine_blk'>
                        <a target="_blank"  onClick={() => navigate("/magazine1", { state: { magazine: "9" } })}>
                                    <img src="https://webapi.entab.info/api/image/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-1 copy.jpg" className='magazine-block img-fluid' />
                                   
                                    <button className='mt-4'>View</button>
                                </a>
                            </div>
                        </div>
                        <div className='col-xxl-2 col-xl-3 col-lg-4 col-md-4 col-sm-4'>
                        <p className='magazine_blk_p'>Nirmalight Vol 3</p>
                        <div className='magazine_blk'>
                        <a target="_blank"  onClick={() => navigate("/magazine1", { state: { magazine: "8" } })}>
                                    <img src="https://webapi.entab.info/api/image/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-1 copy.jpg" className='magazine-block img-fluid' />
                                   
                                    <button className='mt-4'>View</button>
                                </a>
                            </div>
                        </div>
                        <div className='col-xxl-2 col-xl-3 col-lg-4 col-md-4 col-sm-4'>
                        <p className='magazine_blk_p'>Nirmalight Vol 2</p>
                        <div className='magazine_blk'>
                        <a target="_blank"  onClick={() => navigate("/magazine1", { state: { magazine: "7" } })}>
                                    <img src="https://webapi.entab.info/api/image/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-1 copy.jpg" className='magazine-block img-fluid' />
                                   
                                    <button className='mt-4'>View</button>
                                </a>
                            </div>
                        </div>
                        <div className='col-xxl-2 col-xl-3 col-lg-4 col-md-4 col-sm-4'>
                        <p className='magazine_blk_p'>Nirmalight Vol 1</p>
                        <div className='magazine_blk'>
                        <a target="_blank"  onClick={() => navigate("/magazine1", { state: { magazine: "6" } })}>
                                    <img src="https://webapi.entab.info/api/image/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-0.jpg" className='magazine-block img-fluid' />
                                   
                                    <button className='mt-4'>View</button>
                                </a>
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default Magazine;